import React from "react";

function Button({ onClick, type="button", className = '', ...props }) {
    return (

        <>
            <button
                type={type}
                onClick={onClick}
                className={`${className}${" bg-pblue text-white py-4 px-8 text-sm font-medium hover:text-pblue hover:bg-transparent border-2 border-pblue p-2"}`}
                {...props}
            />
        </>
    )
}
export default React.memo(Button)
